import { gapi } from 'gapi-script';
import { createToast, executeAt } from '../../resources/Hooks';
// import { getConfig, setConfig } from '../../resources/configSettings';
import db, { exportBackup, importData } from '../../resources/db';
import moment from 'moment';
import { useContext, useState } from 'react';
import { ConfigContext } from '../../contexts/ConfigContext';
import { useIonLoading } from '@ionic/react';

const API_KEY = process.env.REACT_APP_API_KEY
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID

// Array of API discovery doc URLs for APIs
const DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'];

// Authorization scopes required by the API; multiple scopes can be
// included, separated by spaces.
const SCOPES = 'https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive.appdata';

let min = 1000 * 60;
let hr = 60 * min;
let day = 24 * hr;

let GoogleAuth; // GoogleAuth object

export function useGoogleBackup() {
    const { Config, Company, setConfig } = useContext(ConfigContext);
    const [signedInUser, setSignedInUser] = useState();
    const [isLoadingGoogleDriveApi, setIsLoadingGoogleDriveApi] = useState(false);
    const [presentLoading , dismissLoading] = useIonLoading();

    if (!Config.scheduledBackup) {
        Config.scheduledBackup = {
            enabled: false,
            duration: 7 * day
        }
        setConfig(Config)
    }

    const [BackupSchedule, setBackupSchedule] = useState(Config.scheduledBackup.enabled);
    const [scheduleDuration, setScheduleDuration] = useState(Config.scheduledBackup.duration);

    //scheduleBackup
    const scheduleOnlineBackup = () => {
        const now = moment();
        const lastBackup = new Date(Config.lastBackupOnline);
        const timeDifference = now.diff(lastBackup);

        function backupProcessing() {
            let time = moment().add(5, 'seconds');
            console.log(time, Config.lastBackupOnline);
            console.log(`Backup will be start ${time.fromNow()}`);
            createToast(`Online Backup will be start ${time.fromNow()}. Keep your internet connection on for a while.`, 'warning', 'top');

            executeAt(time, (() => {
                handleClientLoad();
                if (signedInUser) {
                    console.log("starting Backup");
                    takeBackUp();
                } else {
                    createToast('Please sign in to Google Drive to start backup', 'warning', 'top');
                }
            }))
        }

        if (BackupSchedule) if (timeDifference >= scheduleDuration) {
            backupProcessing();
        }
    }


    /**
     *  Sign in the user upon button click.
     */
    const handleAuthClick = (event) => {
        gapi.auth2.getAuthInstance().signIn();
    };

    const handleClientLoad = () => {
        gapi.load('client:auth2', initClient);
    };

    /**
     *  Initializes the API client library and sets up sign-in state
     *  listeners.
     */

    // var GoogleAuth; // Google Auth Object
    const initClient = () => {
        setIsLoadingGoogleDriveApi(true);
        gapi.client.init({
            apiKey: API_KEY,
            clientId: CLIENT_ID,
            discoveryDocs: DISCOVERY_DOCS,
            scope: SCOPES,
        }).then(
            function () {
                GoogleAuth = gapi.auth2.getAuthInstance();
                console.log(GoogleAuth);
                // Listen for sign-in state changes.
                GoogleAuth.isSignedIn.listen(updateSigninStatus);
                // Handle the initial sign-in state.
                updateSigninStatus(GoogleAuth.isSignedIn.get());
                console.log(GoogleAuth.currentUser.get().getBasicProfile());
            },
            function (error) {
                console.log(error);
            }
        );
    };

    /**
 *  Called when the signed in status changes, to update the UI
 *  appropriately. After a sign-in, the API is called.
 */
    const updateSigninStatus = (isSignedIn) => {
        if (isSignedIn) {
            // Set the signed in user
            const user = GoogleAuth.currentUser.get().getBasicProfile().getEmail();
            console.log(user);
            setSignedInUser(user);
            setIsLoadingGoogleDriveApi(false);
        }
        // else {
        //     // prompt user to sign in
        //     handleAuthClick();
        // }
    };

    /**
     *  Sign out the user upon button click.
     */
    const handleSignOutClick = async (event) => {
        setSignedInUser(null)

        var auth2 = gapi.auth2.getAuthInstance();
        auth2.signOut().then(function () {
            console.log('User signed out.');
        });
        // console.log(res);
    };



    /**
     * Take backup of data and upload to google drive 
     */
    const takeBackUp = () => {
        console.log('Starting Backup');
        presentLoading({ message: 'Plase wait while we are backing up your data on cloud' });
        exportBackup().then(async (bkp) => {
            console.log("File Backup Uploading Online...");
            // console.log(bkp);

            createToast("File Backup Uploading Started", 'warning', 'bottom', '3000', 'backupToast1')
            let data = await bkp.text();
            saveData(data).then((res) => {
                dismissLoading();
            });
            // const fileName = `db-backup-${Company.name}-${moment(time).format('LLL')}.dbcx`;
        })
    }

    /**
     * restore Online Backup
     * @param {*} searchTerm 
     */
    async function restoreBackup() {
        try {
            let fileID = await getFiles();
            console.log(fileID);
            if (fileID) {
                createToast("File Backup Downloading Started...", 'warning', 'bottom', '3000', 'backupToast1');
                presentLoading({ message: 'Plase wait while we are restoring your data from Drive' });
                const file = await gapi.client.drive.files.get({
                    fileId: fileID,
                    alt: 'media'
                });
                console.log(file);
                const data = await file.body;
                let blob = new Blob([data], { type: 'text/json' })
                let dataFile = new File([blob], 'db-backup.dbcx', {
                    lastModified: Date.now(), type: ''
                });
                const importDone = data.length && await importData(dataFile);
                if (importDone) {
                    createToast("File Backup Successfully", 'success', 'bottom', '3000', 'backupToast1');
                    dismissLoading();
                    window.location.assign('/');
                } else {
                    dismissLoading();
                    createToast("File Backup Failed", 'danger', 'bottom', '3000', 'backupToastx');
                }
            } else {
                dismissLoading();
                createToast("No Backup File Found", 'danger', 'bottom', '3000', 'backupToast3');
            }
        } catch (error) {
            console.log(error);
        }
    }


    /** 
     * Get file from Google Drive, check if it exists in the database
     * @returns fileID
    */
    const getFiles = async () => {
        console.log("check remote file");
        let fileID = null;
        try {
            const { result } = await gapi.client.drive.files.list({
                spaces: 'appDataFolder',
                q: `name = 'db-backup-billing.dbcx'`,
            });
            console.log(result);
            // createFiles on remote if not exist
            if (result.files.length === 0) {
                fileID = await createFile();
            } else {
                fileID = result.files[0].id;
            }
            return fileID;
        } catch (error) {
            console.log(error);
        }
    }
    /**
     * Create file on Google Drive
     * @returns fileID
    */
    async function createFile () {
        console.log("create remote file");
        try {
            const { result } = await gapi.client.drive.files.create({
                resource: {
                    name: `db-backup-billing.dbcx`,
                    mimeType: 'application/json',
                    parents: ['appDataFolder'],
                },
                fields: 'id',
            });
            console.log(result);
            return result.id;
        } catch (error) {
            console.log(error);
        }
    }

    const saveData = async (data) => {
        let fileData = data;
        let fileID = await getFiles();
        // console.log("save data to remote file");
        try {
            const { result } = await gapi.client.request({
                path: `https://www.googleapis.com/upload/drive/v3/files/${fileID}`,
                method: 'PATCH',
                params: {
                    uploadType: 'media'
                },
                body: fileData,
            });
            // console.log("saved", result);
            localStorage.setItem('lastbkp', result.id);
            Config.lastBackupOnline = moment().format('LLL');
            Config.lastBackupID = result.id;
            db.companies.update(1, {
                lastBackup: result.id,
                lastBackupDate: moment().format('LLL'),
                lastBackupName: result.name,
                config: Config,
            });

            createToast("Cloud Backup Done", 'success', 'bottom', '3000', 'backupToast1');
            return true;
        } catch (error) {
            console.error(error);
            createToast("Cloud Backup Failed. Please Try Again", 'error', 'bottom', '3000', 'backupToast1');
            return false;
        }
    }

    const createFolder = async (folderName) => {
        console.log("create folder");
        try {
            const { result } = await gapi.client.drive.files.create({
                resource: {
                    name: folderName,
                    mimeType: 'application/vnd.google-apps.folder',
                    parents: ['drive'],
                },
                fields: 'id',
            });
            console.log(result);
            return result.id;
        } catch (error) {
            console.error(error);
        }
    }

    return {
        takeBackUp,
        restoreBackup,
        handleClientLoad,
        handleSignOutClick,
        handleAuthClick,
        signedInUser, setSignedInUser,
        scheduleOnlineBackup, isLoadingGoogleDriveApi
    }
}

const boundary = '-------314159265358979323846';
const delimiter = "\r\n--" + boundary + "\r\n";
const close_delim = "\r\n--" + boundary + "--";

const createDriveFile = function (name, data, folder, callback = (file) => {
    console.log(file);
}) {

    const contentType = 'application/json';
    var metadata = {
        'name': name,
        'parents': folder ? [folder] : [],
        'mimeType': contentType
    };

    var multipartRequestBody = delimiter + 'Content-Type: application/json\r\n\r\n' + JSON.stringify(metadata) +
        delimiter + 'Content-Type: ' + contentType + '\r\n\r\n' + data + close_delim;

    var request = gapi.client.request({
        'path': '/upload/drive/v3/files',
        'method': 'POST',
        'params': { 'uploadType': 'multipart' },
        'headers': {
            'Content-Type': 'multipart/related; boundary="' + boundary + '"'
        },
        'body': multipartRequestBody,
    });

    request.execute(callback);
}